/* SS - Match hele familien: add a sibling product to the cart from the strip under the buy
   button (snippets/ss-family-strip.liquid). Kristoffer/Claude 14.09.2026.
   Same flow as the upsell cards in the cart drawer (sections/tcc-cart-drawer.liquid):
   POST /cart/add.js, then the "gOpenCart" event - the drawer re-fetches its sections and opens. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ss-fam__add');
    if (!btn) return;
    var card = btn.closest('[data-ss-fam-card]');
    var sel = card && card.querySelector('.ss-fam__size');
    var vid = btn.getAttribute('data-vid');
    if (sel) {
      if (!sel.value) { (sel.closest('.ss-fam__sizewrap') || sel).classList.add('is-missing'); sel.focus(); return; }
      vid = sel.value;
    }
    btn.disabled = true;
    if (card) card.classList.add('is-adding');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (x) {
        if (!x.ok) console.error('ss-family: add failed', x.d && (x.d.description || x.d.message));
        document.dispatchEvent(new Event('gOpenCart'));
      })
      .catch(function (err) {
        console.error('ss-family: add failed', err);
        document.dispatchEvent(new Event('gOpenCart'));
      })
      .then(function () {
        btn.disabled = false;
        if (card) card.classList.remove('is-adding');
      });
  });
  document.addEventListener('change', function (e) {
    var s = e.target; if (!s.classList || !s.classList.contains('ss-fam__size')) return;
    var wrap = s.closest('.ss-fam__sizewrap'); if (wrap) { wrap.classList.remove('is-missing'); var lab = wrap.querySelector('.ss-fam__sizelabel'); if (lab) lab.textContent = s.options[s.selectedIndex].textContent; }
  });
})();
